.navigationAndIndicator {
	display: flex;
	gap: 12px;
	align-items: center;
}

.pageNavigation {
	display: flex;
	border-radius: 8px;
	border: var(--border-primary) 1px solid;
	overflow: hidden;
	height: 28px;
}

.pageNavigation button:hover {
	background-color: var(--elevation-medium);
}

.pageNavigation button {
	background-color: var(--elevation-default);
	width: 28px;
	height: 28px;
	/*
     * Required to override generic styling from old Layout
     */
	min-width: 28px;
	min-height: 28px;
	color: var(--content-primary);
	padding: 0;
	font-size: unset;
	line-height: unset;
	display: flex;
	align-items: center;
	justify-content: center;
}

.pageNavigation button:disabled {
	background-color: var(--elevation-medium);
	cursor: not-allowed;
}

.pageNavigation button:first-child {
	border-right: var(--border-primary) 1px solid;
}

.pageIndicator {
	color: var(--content-primary);
}

.totalPages {
	opacity: 0.7;
}
